import { render } from "./WarningPopup.vue?vue&type=template&id=2b6271ae"
import script from "./WarningPopup.vue?vue&type=script&lang=js"
export * from "./WarningPopup.vue?vue&type=script&lang=js"

import "./WarningPopup.vue?vue&type=style&index=0&id=2b6271ae&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__